import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { categoryPathReducer, CategoryPathEffects } from './category-path.store';

@NgModule({
  imports: [
    StoreModule.forFeature('categoryPath', categoryPathReducer),
    EffectsModule.forFeature([CategoryPathEffects]),
  ],
  declarations: [],
  exports: [],
})
export class CategoryPathStoreModule {}
